import { ReactNode, 
   useRef,
   } from "react";
import {Dropdown, Menu} from "semantic-ui-react";
import "./NavBar.css";

export function NavBar({items, variant}:{items: {parent?: string, elements: ReactNode | ReactNode[]}[], variant?: 'minimal'}){
    const navRef = useRef<HTMLDivElement>(null);
    const containerClass = variant === 'minimal' 
      ? 'enterprise-dashboard-nav-container nav-minimal' 
      : 'enterprise-dashboard-nav-container';
  
    return (
      <span id="ps-nav-bar">
      <div className={containerClass}>
        <nav ref={navRef} className="scrollable-nav">
          <Menu 
            compact 
            className="enterprise-nav-menu"
            borderless
          >
            {items.map((item) => {
                if(item.parent) {
                    return <Dropdown item simple text={item.parent} key={item.parent} 
                     className="enterprise-dropdown"
                     >
          <Dropdown.Menu
           className="enterprise-dropdown-menu"
           >
                {item.elements}
            </Dropdown.Menu>
            </Dropdown>
                }
                return item.elements;
                })}
          </Menu>
        </nav>
      </div>
      </span>
    );
}